import * as React from 'react'
import { useState, useEffect } from 'react'
import './App.css'
import { MVSCalculatorVergleich } from './components/ui/MVSCalculatorVergleich'
import { Footer } from './components/ui/Footer'
import { Impressum } from './pages/impressum'
import { Datenschutz } from './pages/datenschutz'
import { CookieConsent, ResetCookieConsent } from './components/ui/CookieConsent'
import { initGA, trackPageView } from './lib/analytics'

// Startseite mit Einführung und Button zum Rechner
function SplashScreen({ onEnter }: { onEnter: () => void }) {
  return (
    <div className="text-center p-6 max-w-xl mx-auto">
      <h1 className="text-3xl font-bold mb-4 text-orange-800">Motorbezogene Versicherungssteuer Vergleichsrechner</h1>
      <p className="mb-6 text-orange-700">
        Vergleichen Sie die motorbezogene Versicherungssteuer für Ihr Fahrzeug in Österreich - 
        nach aktueller Regelung und der neuen Berechnung ab 04/2025. 
        Dieser Rechner berücksichtigt alle relevanten Faktoren wie Fahrzeugklasse, 
        Antriebsart, Leistung und CO₂-Emissionen.
      </p>
      <button
        onClick={onEnter}
        className="bg-orange-600 hover:bg-orange-700 text-white font-semibold py-2 px-6 rounded-md shadow-md transition-colors"
      >
        Zum Vergleichsrechner
      </button>
    </div>
  )
}

// Hauptanwendung
function App() {
  const [showSplash, setShowSplash] = useState(true)
  const [currentPage, setCurrentPage] = useState('home')

  // Wechsel zwischen Splash-Screen und Rechner
  const handleEnterCalculator = () => {
    setShowSplash(false)
  }

  // Routing-Logik und Google Analytics initialisieren
  useEffect(() => {
    // Google Analytics initialisieren
    initGA()

    const handleHashChange = () => {
      const hash = window.location.hash.replace('#', '') || 'home'
      setCurrentPage(hash)
      
      // Bei Rückkehr zur Startseite Splash Screen anzeigen
      if (hash === 'home') {
        setShowSplash(true)
      }

      // Seitenaufruf für Analytics tracken
      trackPageView('/' + hash)
    }

    // Initiales Routing
    handleHashChange()

    // Event-Listener für Hash-Änderungen
    window.addEventListener('hashchange', handleHashChange)
    
    // Cleanup
    return () => {
      window.removeEventListener('hashchange', handleHashChange)
    }
  }, [])

  // Rendert die aktuelle Seite basierend auf der Route
  const renderPage = () => {
    switch (currentPage) {
      case 'impressum':
        return <Impressum />
      case 'datenschutz':
        return <Datenschutz />
      default:
        if (showSplash) {
          return <SplashScreen onEnter={handleEnterCalculator} />
        } else {
          return (
            <>
              <button
                onClick={() => setShowSplash(true)}
                className="mb-4 px-3 py-1 bg-orange-100 hover:bg-orange-200 text-orange-800 rounded-md text-sm transition-colors"
              >
                ← Zurück zur Startseite
              </button>
              
              <MVSCalculatorVergleich />
            </>
          )
        }
    }
  }

  return (
    <div className="min-h-screen bg-orange-50 py-8 px-4">
      <div className="max-w-4xl mx-auto">
        {renderPage()}
        
        <Footer />
        
        {/* Cookie-Consent-Banner */}
        <CookieConsent />
        
        {/* Option zum Zurücksetzen des Cookie-Consent-Status im Footer */}
        <div className="text-center mt-4">
          <ResetCookieConsent />
        </div>
      </div>
    </div>
  )
}

export default App 
